import statesServiceGen from "./generated/statesServiceGen";

class statesService extends statesServiceGen {
}

export default statesService;